import { Route } from "@angular/router";
import { PorteurListComponent } from "./porteur-list.component";

export const PorteurListRouting: Route = {
  path: "porteurs",
  component: PorteurListComponent,
  data: {
    breadcrumb: "Liste des utilisateurs"
  }
}
